import React, {PureComponent} from 'react';
import styled, {keyframes} from 'styled-components';

import VisibilityAnimation from '../VisibilityAnimation';

class Loading extends PureComponent {
  static defaultProps = {
    fullScreen: false
  };

  state = {
    stage: 0
  };

  componentDidMount() {
    this.spinnerTimeout = setTimeout(() => this.setState({stage: 1}), 650);
    this.messageTimeout = setTimeout(() => this.setState({stage: 2}), 5000);
  }

  componentWillUnmount() {
    clearTimeout(this.spinnerTimeout);
    clearTimeout(this.messageTimeout);
  }

  render() {
    const {children} = this.props;
    const {stage} = this.state;

    if (stage === 0) {
      return null;
    }

    return (
      <Container {...this.props}>
        <VisibilityAnimation visible show="fade-in" hide="fade-out">
          <Svg xmlns="http://www.w3.org/2000/svg" width="66px" height="66px" viewBox="0 0 66 66">
            <Circle fill="none" strokeWidth="6" strokeLinecap="round" cx="33" cy="33" r="30" />
          </Svg>
        </VisibilityAnimation>
        <Message show="fade-in" hide="fade-out" visible={stage === 2}>
          {children || 'Please wait...'}
        </Message>
      </Container>
    );
  }
}

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(270deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dashoffset: 187;
  }
  50% {
    stroke-dashoffset: 47;
    transform: rotate(135deg);
  }
  100% {
    stroke-dashoffset: 187;
    transform: rotate(450deg);
  }
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: ${props => props.fullScreen ? '100vh' : '100%'};
`;

const Svg = styled.svg`
  animation: ${rotate} 1.4s linear infinite;
`;

const Circle = styled.circle`
  stroke: #0049ee;
  stroke-dasharray: 187;
  stroke-dashoffset: 0;
  transform-origin: center;
  animation: ${dash} 1.4s ease-in-out infinite;
`;

const Message = styled(VisibilityAnimation)`
  height: 3rem;
  padding-top: 2rem;
`;

export default Loading;